import { formatDate } from '@strata/helper-functions';
import { GridWithSearch, SecondaryData } from '@strata/react-grid';
import { HomeScreen } from '@strata/react-page-templates';
import { useNavigate } from 'react-router';

import { ListPageHeader } from 'components/ListPageHeader';
import {
    ApplicationDisplayTextMap,
    formatDisplayColText,
} from 'pages/homeScreenMessaging/HomeScreenHelpers';
import { CREATE_ROUTE } from 'services/constants';
import { useGet } from 'services/Http';

const columns = [
    {
        header: 'Published Date',
        accessorKey: 'publish_date',
        size: 130,
        cell: ({ getValue }) => <SecondaryData data={formatDate(getValue())} />,
    },
    {
        header: 'End Date',
        accessorKey: 'end_date',
        size: 120,
        cell: ({ getValue }) => <SecondaryData data={formatDate(getValue())} />,
    },
    {
        header: 'Feature',
        accessorKey: 'message_category',
        size: 250,
    },
    {
        header: 'Views',
        accessorKey: 'view_count',
        size: 80,
        cell: ({ getValue }) => <SecondaryData data={getValue() ?? 0} />,
    },
    {
        header: 'Slides',
        accessorKey: 'message',
        size: 80,
        cell: ({ getValue }) => <SecondaryData data={getValue()?.length ?? 0} />,
    },
    {
        header: 'Applications',
        accessorKey: 'application',
        size: 160,
        cell: ({ getValue }) => <SecondaryData data={ApplicationDisplayTextMap[getValue()]} />,
    },
    {
        header: 'Display',
        accessorKey: 'display',
        size: 80,
        cell: ({ getValue }) => <SecondaryData data={formatDisplayColText(getValue())} />,
    },
    { header: 'Created By', accessorKey: 'created_by', size: 200 },
    { header: 'Last Modified By', accessorKey: 'last_modified_by', size: 200 },
];

export const CarouselList = () => {
    const navigate = useNavigate();

    const messages = useGet(
        `/announcement/admin/home_screen/message/type/${HomeScreen.MessageType.CAROUSEL}`,
    );

    return (
        <div className="sds_main-content__container">
            <ListPageHeader
                pageTitle="Carousel Announcement"
                buttons={[
                    {
                        label: 'Create Carousel Announcement',
                        path: `/feature-campaign/carousel/${CREATE_ROUTE}`,
                    },
                ]}
            />
            <div className="sds_main-content__grid">
                <GridWithSearch
                    data={messages}
                    isLoading={!messages}
                    columns={columns}
                    sortProperties={[{ id: 'publish_date', desc: true }]}
                    onRowClick={(row) => navigate(`/feature-campaign/carousel/${row.message_id}`)}
                />
            </div>
        </div>
    );
};
